import { Space, Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

function LoadingPage() {
  const isLoading = useSelector(state => state.isLoading);
  if (!isLoading) {
    return null;
  }
  return (
    <Space className="loading-space" size="middle">
      <Spin size="large" />
    </Space>
  );
}

export default LoadingPage;
